<template>
  <v-app id="app">
    <v-app-bar
      app
      dark
      color="transparent"
      class="elevation-0"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="d-lg-none">
        <v-icon>menu</v-icon>
      </v-app-bar-nav-icon>
      <!-- <v-toolbar-title class="mr-12 align-center">
        <router-link id="app-title" class="title white--text" to="/">holoWeb</router-link>
      </v-toolbar-title> -->
    </v-app-bar>

    <nav-drawer v-model="drawer" />

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import NavDrawer from '@/components/NavDrawer.vue'

export default {
  name: 'App',
  components: {
    NavDrawer
  },
  data() {
    return {
      drawer: null
    }
  },
  created() {
    this.$vuetify.theme.dark = true
  }
}
</script>

<style>
html {
  background-color: #343434;
}
html, body {
  overflow: hidden !important;
    position: relative;
}
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
a {
  text-decoration: none;
}

.v-application--wrap {
  min-height: 0 !important;
}
.v-content {
  padding: 0 !important;
}

.text-btn {
  text-transform: none !important;
  font-weight: 400 !important;
  font-size: 1rem !important;
  letter-spacing: 0.5px !important;
}
</style>
